import { put, call, takeEvery, select } from 'redux-saga/effects';

import customerAPI from '../../api/customer';
import { Types, Creators } from '../../reducers/customer';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* customerOrderAddressRequest({ order }) {
  try {
    const token = yield select(getToken);
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);

    const address = yield call(customerAPI.orderInformations, order.hash, 'entrega', token, siteId);

    yield put(Creators.customerOrderAddressSuccess([{ id: order.id, address, addressError: false }], order.id));
  } catch (error) {
    yield put(Creators.customerOrderAddressFailed([{ id: order.id, addressError: true }], order.id));
  }
}

export default function* watch() {
  yield takeEvery(Types.CUSTOMER_ORDER_ADDRESS_REQUEST, customerOrderAddressRequest);
}
